module.exports = __webpack_public_path__ + "img/nationalServiceImg.e3125839.jpg";